import { useContext } from 'react';
import { MentorModalContext } from '@/context/shell-context';
import type { TMentorModal } from '@/context/shell-context';

export const useMentorModal = (): TMentorModal => useContext(MentorModalContext);
